module.exports = __webpack_public_path__ + "static/media/06B.5a6c290a.png";